import { ILogger } from '@featbit/node-server-sdk';

export interface FeatbitConfig {
  sdkKey: string;
  streamingUri: string;
  eventsUri: string;
  userKeyId: string;
  logger?: ILogger;
}

export function makeFeatbitLogger(logger: ILogger): ILogger {
  const fbLogger: ILogger = {
    info: logger.info.bind(logger),
    warn: logger.warn.bind(logger),
    error: logger.error.bind(logger),
    // featbit debug logs are too annoying, so we suppress them
    debug: () => undefined,
  };

  return fbLogger;
}
